import React from 'react';
import PropTypes from 'prop-types';
import { TeamImportItemStatus, TeamImportItemStatusLabel } from '../../../../../../views/democracy/constants';
import Modal from '../../../controls/Modal';

// Модалка результата импорта команд из смены.
export default function ImportResultModal({ result, onClose }) {
    const items = Array.isArray(result.items) ? result.items : [];
    const imported = items.filter(i => i.status === TeamImportItemStatus.IMPORTED);
    const skipped = items.filter(i => i.status !== TeamImportItemStatus.IMPORTED);

    const footer = <button type="button" className="btn btn-primary" onClick={onClose}>OK</button>;

    return (
        <Modal open title="Импорт завершён" onClose={onClose} size="sm" footer={footer}>
            <div className="t-caption">
                Импортировано: {result.imported ?? imported.length} · Пропущено: {result.skipped ?? skipped.length}
            </div>

            {imported.length > 0 && (
                <div className="tmg-imp-sec">
                    <h5 className="ok">Импортировано ({imported.length})</h5>
                    {imported.map(it => (
                        <div className="tmg-imp-row" key={it.campTeamId || it.name}>
                            <span>{it.name}</span><span className="s">joinCode: {it.joinCode}</span>
                        </div>
                    ))}
                </div>
            )}

            {skipped.length > 0 && (
                <div className="tmg-imp-sec">
                    <h5 className="skip">Пропущено ({skipped.length})</h5>
                    {skipped.map(it => (
                        <div className="tmg-imp-row" key={it.campTeamId || it.name}>
                            <span>{it.name}</span><span className="s">{TeamImportItemStatusLabel[it.status] || it.status}</span>
                        </div>
                    ))}
                </div>
            )}
        </Modal>
    );
}

ImportResultModal.propTypes = {
    result: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};
